export default __webpack_public_path__ + "static/media/KOD0073-min.5965681b.webp";